<template>
  <DataCPropProvide :value-style="valueStyle" :animation="false">
    <div class="monitor-container" :id="`meter-${data.uuid}`">
      <!-- 左侧三相参数区域 -->
      <div class="phase-data-section">
        <div class="phase-line"></div>
        <div class="phase-branch branch-a">
          <div class="branch-arrow"></div>
        </div>
        <div class="phase-branch branch-b">
          <div class="branch-arrow"></div>
        </div>
        <div class="phase-branch branch-c">
          <div class="branch-arrow"></div>
        </div>
        <div class="n-label">N</div>

        <div class="phase-header">
          <span>相</span>
          <span>相电流</span>
          <span>有功功率</span>
          <span>无功功率</span>
          <span>功率因数</span>
        </div>

        <div class="phase-card" v-for="phase in ['A', 'B', 'C']">
          <span class="phase-tag">{{ phase }}</span>
          <DataCard style="padding: 0;" title="" :value="data[`i_${phase.toLowerCase()}`]" unit="A" />
          <DataCard style="padding: 0;" title="" :value="data[`p_${phase.toLowerCase()}`]" unit="kW" />
          <DataCard style="padding: 0;" title="" :value="data[`q_${phase.toLowerCase()}`]" unit="kVar" />
          <DataCard style="padding: 0;" title="" :value="data[`pf_${phase.toLowerCase()}`]" />
        </div>


        <!-- 汇总数据 -->
        <div class="summary-section">
          <DataCard class="summary-item" :value="data.p_total" title-position="top" style="grid-column: 3 / 4;"
            unit="kW">
            <template #title>
              <div class="summary-tag">总</div>
            </template>
          </DataCard>
          <DataCard class="summary-item" :value="data.q_total" title-position="top" unit="kVar">
            <template #title>
              <div class="summary-tag">总</div>
            </template>
          </DataCard>
          <DataCard class="summary-item" :value="data.pf" title-position="top">
            <template #title>
              <div class="summary-tag">总</div>
            </template>
          </DataCard>          
        </div>

        <div class="input-arrow arrow-a"></div>
        <div class="input-arrow arrow-b"></div>
        <div class="input-arrow arrow-c"></div>
      </div>

      <!-- 负载区域 -->
      <div class="load-section">负载</div>

      <!-- 右侧数据展示区域 -->
      <div class="right-data-section">
        <div class="energy-card">
          <DataCard title="频率" :value="data.f" unit="Hz"></DataCard>
          <DataCard title="正向有功电能" :value="fmt(data.e_positive)" unit="kWh">
          </DataCard>
          <DataCard title="反向有功电能" :value="fmt(data.e_reverse)" unit="kWh">
          </DataCard>
          <!-- <v-btn variant="text" rounded="xl" color="var(--color-primary)">更多</v-btn> -->
          <v-menu open-on-hover location="top">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" variant="text" rounded="xl" color="var(--color-primary)">更多</v-btn>
            </template>
            <v-card class="pa-4">
              <v-table class="gm-table">
                <thead>
                  <tr>
                    <th class="text-indigo-accent-4">方向</th>
                    <th class="text-indigo-accent-4">尖</th>
                    <th class="text-indigo-accent-4">峰</th>
                    <th class="text-indigo-accent-4">平</th>
                    <th class="text-indigo-accent-4">谷</th>
                    <th class="text-indigo-accent-4">深谷</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>正向</td>
                    <td>{{ fmt(data.e_positive_sharp) }}</td>
                    <td>{{ fmt(data.e_positive_peak) }}</td>
                    <td>{{ fmt(data.e_positive_flat) }}</td>
                    <td>{{ fmt(data.e_positive_valley) }}</td>
                    <td>{{ fmt(data.e_positive_deep_valley) }}</td>
                  </tr>
                  <tr>
                    <td>反向</td>
                    <td>{{ fmt(data.e_reverse_sharp) }}</td>
                    <td>{{ fmt(data.e_reverse_peak) }}</td>
                    <td>{{ fmt(data.e_reverse_flat) }}</td>
                    <td>{{ fmt(data.e_reverse_valley) }}</td>
                    <td>{{ fmt(data.e_reverse_deep_valley) }}</td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>            
          </v-menu>
        </div>

        <div class="voltage-card">
          <!-- <div class="curve-btn"><v-btn variant="text" rounded="xl" color="var(--color-primary)">电压对比曲线</v-btn></div> -->
          <div class="voltage-triangle">
            <div class="triangle-line line-to-a"></div>
            <div class="triangle-line line-to-b"></div>
            <div class="triangle-line line-to-c"></div>

            <div class="phase-node node-a">
              <Flash />
            </div>
            <div class="phase-node node-b">
              <Flash />
            </div>
            <div class="phase-node node-c">
              <Flash />
            </div>

            <div class="phase-label label-a">A</div>
            <div class="phase-label label-b">B</div>
            <div class="phase-label label-c">C</div>
          </div>

          <div class="voltage-data">
            <DataCard title="AB线电压" :value="data.u_ab" unit="V" value-style="font-size: 16px;font-weight: bold">
            </DataCard>
            <DataCard title="BC线电压" :value="data.u_bc" unit="V" value-style="font-size: 16px;font-weight: bold">
            </DataCard>
            <DataCard title="CA线电压" :value="data.u_ca" unit="V" value-style="font-size: 16px;font-weight: bold">
            </DataCard>
          </div>
        </div>
      </div>
    </div>
  </DataCPropProvide>
</template>
<script setup>
import DataCard from '@/components/DataCard/index.vue'
import DataCPropProvide from '@/components/DataCard/PropProvide.vue'
import Flash from './Flash.vue'
import { fmtp, fmte } from '@/utils/fortmatter'

function fmt(value) {
  if (typeof value === 'number') {
    return value.toLocaleString('zh-CN')
  }
  return '--'
}

const valueStyle = {
  'font-size': '14px',
  'font-weight': 'bold',
}


const props = defineProps({
  data: {
    default: () => { },
    type: Object,
  }
})

</script>
<style scoped lang="scss">
.monitor-container {
  display: flex;
  align-items: center;
  gap: 28px;
  max-width: 1600px;
  min-width: 0;
  width: 100%;
  margin: 0 auto;


  --columns: 58px repeat(4, minmax(88px, 1fr));
  --margin-left: 70px;
}

/* 左侧三相参数区域 */
.phase-data-section {
  flex: 1 1 0;
  position: relative;
  min-width: 0;
}

.phase-header {
  display: grid;
  grid-template-columns: var(--columns);
  padding: 10px 0;
  color: #2e2e2e80;
  font-weight: 500;
  margin-left: var(--margin-left);
  text-align: center;
  min-width: 0;
}

.phase-line {
  position: absolute;
  left: 40px;
  top: 60px;
  width: 1px;
  height: 124px;
  background: linear-gradient(to bottom, #87ceeb 0%, #87ceeb 100%);
  border-radius: 2px;
}

.phase-branch {
  position: absolute;
  left: 40px;
  width: 30px;
  height: 1px;
  background: linear-gradient(to right, #87ceeb 0%, #87ceeb 100%);
  border-radius: 2px;
}

.branch-a {
  top: 60px;
}

.branch-b {
  top: 122px;
}

.branch-c {
  top: 184px;
}

.branch-arrow {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 10px solid #87ceeb;
}

.n-label {
  position: absolute;
  left: 20px;
  top: 39%;
  transform: translateY(-50%);
  // font-size: 32px;
  color: #333;
  // font-weight: bold;
}

.phase-card {
  margin-left: var(--margin-left);
  margin-bottom: 16px;
  padding: 10px;
  background: #ffffff;
  border: 1px solid #CBEBFA;
  border-radius: 12px;
  display: grid;
  grid-template-columns: var(--columns);
  align-items: center;
  min-width: 0;
  /* font-size: 28px; */
  color: #333;
  text-align: center;
}

.phase-card:last-child {
  margin-bottom: 0;
}

.phase-tag {
  font-weight: bold;
}

/* 负载区域 */
.load-section {
  width: 80px;
  min-width: 68px;
  height: 175px;
  border: 2px dashed #ffcc99;
  border-radius: 8px;
  background-color: #fff9f0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* font-size: 28px; */
  // font-weight: bold;
  color: #333;
  position: relative;
  top: -25px;
}

.load-arrow {
  position: absolute;
  left: -40px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 3px;
  background: #add8e6;
}

.load-arrow::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 10px solid #add8e6;
}

/* 右侧数据展示区域 */
.right-data-section {
  flex: 0 0 360px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
}

.energy-card {
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);
  border-radius: 12px;
  padding: 12px 0px 16px 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid #e0f0ff;
  min-width: 0;
  overflow: hidden;

  > .v-btn {
    flex: 0 0 auto;
    margin-left: auto;
  }

  :deep(.data-card) {
    flex: 0 1 auto;
    min-width: 0;
    padding: 0;
    gap: 8px;
  }

  :deep(.data-card__body) {
    min-width: 0;
  }

  :deep(.data-card__value) {
    white-space: nowrap;
  }
}

.energy-item {
  text-align: center;
}

.energy-label {
  color: #666;
  margin-bottom: 8px;
}

.energy-value {
  color: #333;
  font-weight: bold;
}

.voltage-card {
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid #e0f0ff;
  position: relative;
}

.voltage-triangle {
  width: 72px;
  height: 92px;
  position: relative;
}

.triangle-line {
  position: absolute;
  background: #96A5B8;
  z-index: 1;
  height: 2px;
  transform-origin: left center;
  margin-top: -1px;
}

/* 重心 (50, 182.5/3) → 各节点圆心 A(50,17.5) B(82.5,82.5) C(17.5,82.5) */
.line-to-a {
  left: 50px;
  top: calc(182.5px / 3);
  width: calc(182.5px / 3 - 17.5px);
  transform: rotate(-90deg);
}

.line-to-b {
  left: 50px;
  top: calc(182.5px / 3);
  width: 39.060139px;
  transform: rotate(33.690068deg);
}

.line-to-c {
  left: 50px;
  top: calc(182.5px / 3);
  width: 39.060139px;
  transform: rotate(146.309932deg);
}

.phase-node {
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #BDD3FF;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 10px;
  z-index: 2;
}

.node-a {
  top: 10px;
  left: 42.5px;
}

.node-b {
  top: 75px;
  left: 75px;
}

.node-c {
  top: 75px;
  left: 10px;
}

.phase-label {
  position: absolute;
  font-size: 12px;
  font-weight: bold;
  color: #333;
}

.label-a {
  top: -9;
  left: 45px;
}

.label-b {
  top: 85px;
  left: 94.5px;
}

.label-c {
  top: 85px;
  left: 1.5px;
}

.voltage-data {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.voltage-item {
  text-align: center;
}

.voltage-label {
  font-size: 22px;
  color: #666;
  margin-bottom: 8px;
}

.voltage-value {
  font-size: 28px;
  color: #333;
  font-weight: bold;
}

.curve-btn {
  position: absolute;
  top: 0px;
  right: 20px;
  // padding: 8px 16px;
  // background: linear-gradient(135deg, #b3d8ff 0%, #87ceeb 100%);
  // border-radius: 20px;
  // color: #409eff;
  // font-size: 18px;
  // font-weight: 500;
  // cursor: pointer;
}

/* 底部汇总数据 */
.summary-section {
  display: grid;
  grid-template-columns: var(--columns);
  margin-left: var(--margin-left);
  // padding: 16px;
  text-align: center;
  min-width: 0;

  :deep(.data-card__value) {
    display: flex;
    align-items: center;
  }

  :deep(.data-card__body) {
    justify-content: center;
    gap: 8px;
    align-items: center;
  }
}

.summary-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
}

.summary-tag {
  padding: 4px 8px;
  background: linear-gradient(135deg, #b3d8ff 0%, #87ceeb 100%);
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  display: inline-block;
}

.summary-value {
  /* font-size: 32px; */
  color: #333;
  font-weight: bold;
  display: flex;
  align-items: center;
}

/* 箭头装饰 */
.input-arrow {
  position: absolute;
  right: -40px;
  width: 40px;
  height: 2px;
  background: #add8e6;
}

.input-arrow::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 10px solid #add8e6;
}

.arrow-a {
  top: 60px;
}

.arrow-b {
  top: 122px;
}

.arrow-c {
  top: 184px;
}

@media (max-width: 1366px) {
  .monitor-container {
    gap: 20px;
    --columns: 48px repeat(4, minmax(76px, 1fr));
    --margin-left: 62px;
  }

  .phase-card {
    padding-left: 6px;
    padding-right: 6px;
  }

  .load-section {
    width: 68px;
  }

  .right-data-section {
    flex: 0 0 360px;
  }

  .energy-card,
  .voltage-card {
    padding: 12px;
  }

  .voltage-triangle {
    width: 80px;
    height: 80px;
  }
}

@media (max-width: 1024px) {
  .monitor-container {
    align-items: stretch;
    flex-direction: column;
  }

  .load-section,
  .input-arrow {
    display: none;
  }

  .right-data-section {
    flex-basis: auto;
  }
}
</style>
